import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import { Box, Stack } from "@mui/material";
import { SectionTitle } from "@components/PhotoFilters/SectionTitle";
import { UseFormReturn } from "react-hook-form";
import { PhotoSearchFilters } from "@store/photoApi";
import ReactHookFormDatePicker from "@components/ReactHookFormDatePicker/ReactHookFormDatePicker";
import CustomLabelInput from "@components/CustomLabelInput";
import { useMediaQuery } from "react-responsive";
import { ScreenSize } from "@constants/screen-size";

const DateFilters: FC<{
  form: UseFormReturn<PhotoSearchFilters>;
}> = ({ form: { control } }) => {
  const { t } = useTranslation();
  const isSmScreen = useMediaQuery({
    query: `(max-width: ${ScreenSize.md}px)`,
  });

  return (
    <Stack>
      <SectionTitle>
        {t("albums.addPhotosDialog.filters.dates.title")}
      </SectionTitle>

      <Stack flexDirection={isSmScreen ? "column" : "row"} gap="8px">
        <CustomLabelInput
          label={t("albums.addPhotosDialog.filters.dates.startDateInput.label")}
          id="startDate"
        >
          <ReactHookFormDatePicker
            slotProps={{ textField: { size: "small", fullWidth: true } }}
            id="startDate"
            controller={{
              name: "startDate",
              control,
              defaultValue: null,
            }}
          />
        </CustomLabelInput>

        {!isSmScreen && (
          <Box
            display="flex"
            alignItems="flex-end"
            justifyContent="center"
            marginBottom="10px"
          >
            -
          </Box>
        )}

        <CustomLabelInput
          label={t("albums.addPhotosDialog.filters.dates.endDateInput.label")}
          id="endDate"
        >
          <ReactHookFormDatePicker
            slotProps={{ textField: { size: "small", fullWidth: true } }}
            id="endDate"
            controller={{
              name: "endDate",
              control,
              defaultValue: null,
            }}
          />
        </CustomLabelInput>
      </Stack>
    </Stack>
  );
};

export default DateFilters;
